import { useEffect } from 'react';

import { logError } from '@/lib/errorLogging';

import { type SpriteSummary, spritesStore } from './sprites.store';

export const useSpriteForFile = (
  fileId: string | undefined
): SpriteSummary | undefined => {
  useEffect(() => {
    spritesStore.loadSpriteFor(fileId).catch((error: unknown) => {
      logError(error, 'Failed to load sprites', {
        context: 'useSpriteForFile',
      });
    });
  }, [fileId]);

  return fileId
    ? spritesStore.sprites.find((sprite) => sprite.file_id === fileId)
    : undefined;
};
